import { Layout, LayoutProps } from 'react-admin';

import { CustomMenu } from './CustomMenu';

export const CustomLayout: React.FC = (props: LayoutProps) => <Layout {...props} menu={CustomMenu} />;
